import { iLedger } from "@sdk/ledgers/ledgers-models";
import { iStore } from "../../store.model";
import { CreateSelectorForEntities } from "../../utils/entity-slice-creator";

export const {
  selectQueryMap: selectLedgerQueryMap,
  selectEntityMap: selectLedgersMap,
  selectQueryMapAll: selectLedgersMapAll,
  selectQueryAllList: selectLedgersAllList,
  selectAllEntities: selectAllLedgers,
  selectAllEntitiesQuery: selectAllLedgersQuery,
  selectEntityById: selectLedgerById,
  selectEntityQuery: selectLedgerQuery,
  selectEntityQueryList: selectLedgerQueryList,
} = CreateSelectorForEntities<iStore, iLedger>({
  sliceName: "ledgers",
});

